module.exports = __webpack_public_path__ + "img/proof-marker.d9815a50.png";